import React, { useCallback, useState } from 'react';
import { IconButton } from '../IconButton';
import { IconEye, IconEyeOff } from '../QuirkIcons';
import { FormErrors } from './FormErrors';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './FormFields.module.css';
import classNames from 'classnames';

interface InputProps<T> {
	placeholder?: string;
	name?: string;
	type?: 'url' | 'text' | 'number' | 'password' | 'email' | 'color';
	label?: string;
	onChange?: (e: any) => void;
	onBlur?: (e: any) => void;
	onPaste?: (e: any) => void;
	autoComplete?: string;
	errors?: string[];
	color?: string;
	disabled?: boolean;
	width?: string;
	gap?: number;
	value?: T;
	inputRef?: React.RefObject<HTMLInputElement> | ((node: HTMLInputElement) => void);
	id?: string;
	step?: string;
	min?: string;
	max?: string;
	tabIndex?: number;
	testId?: string;
	className?: string;
}

export function Input<T extends string | number>({
	placeholder,
	name,
	value,
	type,
	label,
	onChange,
	onBlur,
	onPaste,
	tabIndex,
	autoComplete,
	disabled,
	errors,
	color,
	width,
	id,
	step,
	min,
	max,
	inputRef,
	testId,
	className
}: InputProps<T>): JSX.Element {
	const [passwordVisible, setPasswordVisible] = useState(false);
	const unmaskPassword = () => {
		setPasswordVisible(!passwordVisible);
	};

	const fieldType = useCallback(() => {
		if (type === 'password') {
			if (passwordVisible) {
				return 'text';
			} else {
				return 'password';
			}
		} else {
			return type || 'text';
		}
	}, [passwordVisible, type]);

	return (
		<div className={styles.fieldHolder} style={{ width: width || '100%' }} data-testid={testId}>
			{label && <div className={styles.label}>{label}</div>}
			{type === 'password' && (
				<div className={styles.fieldIcon}>
					<IconButton icon={passwordVisible ? <IconEyeOff /> : <IconEye />} onClick={unmaskPassword} />
				</div>
			)}

			<input
				style={{
					color: errors && errors.length > 0 ? 'red' : color,
					paddingRight: type === 'password' ? '45px' : '0px'
				}}
				tabIndex={tabIndex}
				className={classNames(styles.input, className)}
				id={id && id}
				placeholder={placeholder || 'Placeholder'}
				name={name && name}
				type={fieldType()}
				step={step || undefined}
				min={type === 'number' ? min : undefined}
				max={type === 'number' ? max : undefined}
				value={value ?? ''}
				// step={step ? step : undefined}
				onBlur={onBlur && onBlur}
				onKeyDown={e => {
					e.key === 'Enter' && onBlur && onBlur(e);
				}}
				onChange={onChange && onChange}
				onPaste={onPaste && onPaste}
				ref={inputRef}
				autoComplete={autoComplete || 'off'}
			/>
			<FormErrors errors={errors} />
		</div>
	);
}
